import { t } from "adapters/i18n";
import type { WeightGainCurve } from "shared/types";
import type { DataResult, ServiceConstructor } from "../services.types";

export function WeightGainCurveServiceMixin<TBase extends ServiceConstructor>(
  Base: TBase
) {
  return class WeightGainCurveService extends Base {
    readonly weightGainCurveUrl = `${process.env.REACT_APP_ENDPOINT}herds/weightGainCurve`;

    async listCurvesForFarm(
      farmId: number
    ): Promise<DataResult<WeightGainCurve>> {
      try {
        const params = this.montaURLParametros({ farmId });
        const url = this.montaURL(this.weightGainCurveUrl, params);
        const response = await this.get(url);

        if (response.data?.data == null) {
          return { data: [], total: 0 };
        }

        const data = response.data.data as WeightGainCurve[];
        const total = response.data.total as number;

        return { data, total };
      } catch (_) {
        throw new Error(t("livestock:fetch-weight-gain-curves-error"));
      }
    }
  };
}
